function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import { Alert } from 'reactstrap';
import { positions, transitions, useAlert, withAlert, Provider } from 'react-alert';
var alertOptions = {
  position: positions.TOP_CENTER,
  timeout: 5000,
  offset: '0px',
  transition: transitions.FADE,
  containerStyle: {
    marginTop: '175px'
  }
};
var typeToColor = {
  error: 'danger',
  info: 'info',
  success: 'success'
};

var AlertTemplate = function AlertTemplate(_ref) {
  var message = _ref.message,
      options = _ref.options,
      style = _ref.style,
      close = _ref.close;
  return /*#__PURE__*/React.createElement(Alert, {
    color: typeToColor[options.type],
    fade: false,
    style: {
      style: style
    },
    toggle: close
  }, /*#__PURE__*/React.createElement("span", null, message));
};

var AlertProvider = function AlertProvider(_ref2) {
  var children = _ref2.children,
      rest = _objectWithoutProperties(_ref2, ["children"]);

  return /*#__PURE__*/React.createElement(Provider, _extends({
    template: AlertTemplate
  }, alertOptions, rest), children);
};

export { AlertProvider as Provider, AlertTemplate as Template, alertOptions as options, useAlert, withAlert };